// home.js
import React, { useEffect, useRef } from 'react';
import styles from './home.module.css';

function Home() {
const fraseContainerRef = useRef(null);

useEffect(() => {
    // Efecto de carga inicial
    setTimeout(() => {
    if (fraseContainerRef.current) {
        fraseContainerRef.current.style.opacity = '1';
    }
    }, 100);
}, []);

return (
    <section id='home' className={styles.home}>
    <div className={styles.foto}>
        <div 
        ref={fraseContainerRef}
        className={styles.fraseContainer}
        style={{ opacity: 0 }}
        >
        <div className={styles.frase}>
            <p>Lautaro Mazza has resolved to enter the world of tango renouncing all innocence. Understanding the dangers of a complacent attitude1, he faced the hardship2 of study. He disdained the misleading advice that suggested being authentic or being himself, understanding that such notions3 meant nothing. And so,4 he began to build a voice day after day, with great effort, following the teachings of true masters. He also had the foresight to learn more than just5 music, because he understood that an artist has the obligation to comprehend how the world works – and6 to exercise himself in thought, and even in ethics. Thus, to the astonishment of some strangers7 like me, he became one of the two best singers in this country. His voice bears no imperfections, his intonation is flawless. His choice of repertoire indicates that he knows a bitter truth: Not all tangos are good. Moreover8, he has intentionally designed a control over his versions, with impeccable selection of tempos, phrasings, and noble "manieras" that are characteristic of the genre. This being the case, Lautaro has no need to cheat. He can dispense with gestures and stamps9 on the floor. He does not have to give explanations after each song. It may seem simple, but it is blessedly complex.</p>
            <p className={styles.firma}>Alejandro Dolina</p>
        </div>
        </div>
    </div>
    </section>
);
}

export default Home;